module.exports = require("@swa-ui/placements/src/BannerGrid/BannerGridLayout3.module.scss");